import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class TextArea extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,isEvent} = this.props;
    if(isEvent===true){
      changeHandler(e.target.value,e);
    }else{
      changeHandler(e.target.value);
    }
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);    
    return (
      <Wrp>
        <textarea 
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}
        >{value}</textarea>
      </Wrp>        
    );
  }
}

TextArea.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  isEvent:false
}

export default TextArea;